export enum AdditionalArticleUnit {
  Piece = "Piece",
  Meter = "Meter",
  Set = "Set",
  Pair = "Pair",
  FlatRate = "FlatRate",
}

export const ADDITIONAL_ARTICLE_UNIT_LABELS: Record<
  AdditionalArticleUnit,
  string
> = {
  [AdditionalArticleUnit.Piece]: "Stück",
  [AdditionalArticleUnit.Meter]: "Meter",
  [AdditionalArticleUnit.Set]: "Set",
  [AdditionalArticleUnit.Pair]: "Paar",
  [AdditionalArticleUnit.FlatRate]: "Pauschal",
};
